import { ProjectCustomFieldsAttribute } from "src/app/services/response-models/projects.response.model";

export class SetProjectCustomFieldAttributes {
    public static readonly type = "[Projects] Set project custom fields attributes";

    constructor(public payload: ProjectCustomFieldsAttribute[]) {}
}
